import { render, staticRenderFns } from "./psd-preview.vue?vue&type=template&id=64b6c232"
import script from "./psd-preview.vue?vue&type=script&lang=js"
export * from "./psd-preview.vue?vue&type=script&lang=js"
import style0 from "./psd-preview.vue?vue&type=style&index=0&id=64b6c232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports